export default defineAppConfig({
  ui: {
    primary: 'green',
    gray: 'neutral',
  }
})